import axios from "axios";
import { useState } from "react";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import Modal from "../Modal/Modal";

const UnMergeConfirmationModal = ({ showModal, onClose, onSuccess, from, selectedItem }) => {
  const [config] = useAuth();
  const [error, setError] = useState();

  const typeNames = {
    contact: "contact",
    company: "company",
    property: "property",
  };

  const handleClose = () => {
    setError();
    onClose();
  };

  const handleConfirm = (e) => {
    e.preventDefault();
  const dataToSend = {
      action: "ringcenter",
      items: selectedItem,
      type: from, 
    };

    axios
      .post(`${BASE_URL}/ringcentral/push-contacts-by-met-status`, dataToSend, config)
      .then((res) => {
        onSuccess();
        handleClose();
      })
      .catch((error) => {
        console.error("Error merging contacts:", error);
        setError(error.response?.data?.message || "An error occurred.");
      });
  };

  return (
    <Modal width="700px" show={showModal} onClose={onClose}>
      <form onSubmit={handleConfirm} className="text-center">
        <div className="flex-1 text-center w-30">
          <p className="head-1 dark-H font-bold">RingCentral</p>
          <p className="py-1 dark-M body-L">
             Are you sure you want to push the {typeNames[from]} to RingCentral? 
          </p>
        </div>

        <div className="mt-6 mb-6 flex justify-center">
          <button
            type="submit"
            className="save-button light-L head-5 green-bg-H px-[30px] py-[12px]"
          >
            Push
          </button>
          <button
            type="button"
            onClick={handleClose}
            className="green-H body-N ml-5"
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default UnMergeConfirmationModal ;


